
import { defineComponent, onMounted } from 'vue';
import { AppTable, AppCard, AppButton } from '@/components';
import { useTournamentLeaderboardList } from '@/modules/tournament/leaderboard/model/list';
import { ROUTE_NAME_TOURNAMENT } from '@/modules/tournament/router';
import { TableColumnType, TableConfig } from '@/components/table/types';
import { timeUnits } from '@/common/utils/helpers';

export default defineComponent({
    name: ROUTE_NAME_TOURNAMENT.LEADERBOARD.INDEX,
    components: { AppTable, AppCard, AppButton },
    setup() {
        const { list, total, query, fetchList, actions } = useTournamentLeaderboardList();

        const table: TableConfig = {
            columns: [
                { type: TableColumnType.Text, label: 'ID', key: 'id' },
                { type: TableColumnType.Text, label: 'Name', key: 'name' },
                { type: TableColumnType.Option, label: 'Time Unit', key: 'timeUnit', options: timeUnits },
                { type: TableColumnType.Text, label: 'Time Duration', key: 'timeDuration' },
                { type: TableColumnType.DateTime, label: 'Publish Time', key: 'publishTime' },
                { type: TableColumnType.DateTime, label: 'Unpublish Time', key: 'unpublishTime' },
                { type: TableColumnType.Option, label: 'Status', key: 'status', options: statusList },
                { type: TableColumnType.Actions, label: 'Actions' }
            ],
            actions: [
                {
                    props: (row: any) => ({
                        icon: 'fa-eye',
                        theme: 'info',
                        tooltip: 'Detail',
                        to: { name: ROUTE_NAME_TOURNAMENT.LEADERBOARD.DETAIL, params: { id: row.id } }
                    }),
                    group: 0
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-edit',
                        theme: 'info',
                        tooltip: 'Edit',
                        to: { name: ROUTE_NAME_TOURNAMENT.LEADERBOARD.EDIT, params: { id: row.id } }
                    }),
                    group: 0
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-medal',
                        theme: 'info',
                        tooltip: 'Show medal',
                        to: { name: ROUTE_NAME_TOURNAMENT.LEADERBOARD.MEDAL, params: { id: row.id } }
                    }),
                    group: 1
                },
                {
                    props: (row: any) => ({
                        icon: 'fa-trash-alt',
                        theme: 'danger',
                        tooltip: 'Delete',
                        disabled: !row.canDelete,
                        onClick: () => actions.remove(row.id)
                    })
                }
            ]
        };

        onMounted(fetchList);

        return { table, list, total, query, fetchList, ROUTE_NAME_TOURNAMENT };
    }
});

const statusList = [
    { label: 'None', value: 0, background: 'secondary' },
    { label: 'Published', value: 1, background: 'success' },
    { label: 'Unpublished', value: 2, background: 'secondary' }
];
